import { useCallback } from 'react';
import { useNavigate, useMatch } from 'react-router';

import { CrmStore } from './types';
import { useCrmStore, initCrmStoreState } from './useCrmStore';

export const setCrmStoreDetail = ({
  storeId,
  storeName,
  chats,
  saleChannels,
  isEnabled,
  isInfluencerMode,
  hasSlackNotifications,
  draftReplyEnabled,
  slackChannelId,
}: CrmStore) => {
  useCrmStore.setState((state) => {
    state.storeId = storeId;
    state.storeName = storeName;
    state.chats = chats;
    state.saleChannels = saleChannels;
    state.isEnabled = isEnabled;
    state.isInfluencerMode = isInfluencerMode;
    state.hasSlackNotifications = hasSlackNotifications;
    state.draftReplyEnabled = draftReplyEnabled;
    state.slackChannelId = slackChannelId;
  });
};

/**
 * When user switch store, reset the store state and only preset the storeId/storeName.
 * On `CrmAppRoot`, a subscriber will validate this new storeId
 */
export const switchStore = ({
  storeId,
  storeName = '',
}: {
  storeId: string;
  storeName?: string;
}) => {
  useCrmStore.setState({
    ...initCrmStoreState,
    storeId,
    storeName,
  });
};

export const useReloadCrmStoreAndPath = () => {
  const navigate = useNavigate();
  const withStoreIdPath = useMatch({ path: '/crm/:module/:storeId', end: false });

  const reloadCrmStoreAndPath = useCallback(
    ({ storeId, storeName = '' }: { storeId: string; storeName?: string }) => {
      switchStore({ storeId, storeName });

      if (withStoreIdPath) {
        const { module } = withStoreIdPath.params;
        if (!module) return;
        navigate(`/crm/${module}/${storeId}`);
      }
    },
    [withStoreIdPath, navigate]
  );

  return {
    reloadCrmStoreAndPath,
  };
};
